export const variantColor: Record<string, string> = {
  active: 'seaBlue.main',
  completed: 'landGreen.41',
  optional: 'seaBlue.45',
  pending: 'sandstone.90',
  error: 'energyRed.main',
}

export const titleColor = {
  active: 'sandstone.10',
  completed: 'sandstone.10',
  optional: 'sandstone.10',
  pending: 'sandstone.55',
  error: 'energyRed.main',
}

export const boldTitles = ['active', 'error']

export const stepClassName = 'vui-stepHorizontal'

export const tailClassName = stepClassName + 'Tail'

export const tailClassNameLeft = tailClassName + 'Left'

export const tailClassNameRight = tailClassName + 'Right'
